import React from 'react';
import { withRouter } from 'react-router';
import { productCategories, downloadCatalogue } from '../../../queries';
import { graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { toggleMenu } from '../../../actions/index';
import { PdfIcon } from 'dab-component-lib';
import I18n from '../../../I18n/I18n';
import { SecNavStyle, CatalogueLink, Labels, Label, MobileTitleStyle } from './style';
import { GridContainerStyle, GridRowStyle } from '../../../utils/style-utils';

class SecondaryNavigation extends React.Component {

  closeMenu(){
    const {openMenu, dispatch} = this.props;
    if(openMenu.value){
      dispatch(toggleMenu(false));
    }
  };

  onClickHandler = (tid) => {
    this.closeMenu();
    this.props.history.push(`/category/${tid}`)
  };

  downloadCatalogue = url => {
    window.open(url, "__blank")
  };

  render() {
    const {productCategories, downloadCatalogue, openMenu: {value}} = this.props;
    let categories = [];
    if(!productCategories.loading && !productCategories.error){
      productCategories.feNavigationMenuTermsGraphql1View.results.forEach(category => {
        categories.push(category);
      });
      categories = categories.sort((a, b) => {
        return (a.weight > b.weight ? 1 : ((b.weight > a.weight) ? -1 : 0));
      });
    }
    return (
      <SecNavStyle openMenu={value}>
        <GridContainerStyle>
          <GridRowStyle center>
            {
              (!downloadCatalogue.loading && !downloadCatalogue.error && downloadCatalogue.nodeQuery.entities.length > 0) &&
              <CatalogueLink
                onClick={() => this.downloadCatalogue(downloadCatalogue.nodeQuery.entities["0"].fieldPdfFile.entity.url)}>
                <PdfIcon
                  color="#004615"
                  size={30}
                /> <span>{I18n.t('content.getCatalogue')}</span>
              </CatalogueLink>
            }
            {
              (!productCategories.loading && !productCategories.error) &&
              <div>
                <MobileTitleStyle>
                  Categories
                </MobileTitleStyle>
                <Labels>
                  {
                    categories.map(category =>
                      <li key={category.tid}>
                        <Label onClick={() => this.onClickHandler(category.tid)}>
                          {category.name}
                        </Label>
                      </li>
                    )
                  }
                </Labels>
              </div>
            }
          </GridRowStyle>
        </GridContainerStyle>
      </SecNavStyle>
    );
  }
}

const mapStateToProps = ({openMenu}) => {
  return {
    openMenu
  }
};


export default connect(mapStateToProps)(compose(
  graphql(productCategories, {
    name: 'productCategories',
    options: props => ({
      variables: {
        lang: localStorage.getItem('language') ? localStorage.getItem('language') : "it"
      }
    })
  }),
  graphql(downloadCatalogue, {name: 'downloadCatalogue'})
)(withRouter(SecondaryNavigation)));


// WEBPACK FOOTER //
// ./src/components/common/secNav/index.js